import React from "react";
import Markdown from "markdown-to-jsx";
import { Link } from "react-router-dom";

import InputCard from "../../components/InputCard/InputCard";
import MainTitle from "../../components/MainTitle/MainTitle";
import Button from "../../shared/Button/Button";
import IndicatiorCircle from "../../shared/IndicatorNumber/IndicatiorCircle";
import LoginLogic from "./LoginLogic";
import InformationText from "../../shared/InformationText/InformationText";
import Information from "../../components/InformationAlert/Information";
import Heading from "../../shared/Heading/Heading";
import LoadingContainer from "../../shared/LoadingContainer/LoadingContainer";
import Logo from "../../shared/Logo/Logo";
import BlurryWrapper from "../../components/UI/BulurryWrapper/BlurryWrapper";
import WindowWidth from "../../hooks/WindowWidth";
import PromotionalBanner from "../PromotionalPage/PromotionalBanner";
import AlertBox from "../../components/AlertBox/AlertBox";

import styles from "./login.module.css";

const LoginOld = () => {
  const {
    isWaitingToLogIn,
    formData,
    loginPageData,
    isError,
    loading,
    selectedHotel,
    bannerTexts,
    hasSessionExpired,
    manageFormData,
    handleRequest,
    setHasSessionExpired,
    setSelectedHotel,
  } = LoginLogic();

  const { width } = WindowWidth();

  return (
    <>
      {loading ? (
        <div style={{ minHeight: "100vh" }}>Loading...</div>
      ) : (
        <section
          className={styles.loginWrapper}
          style={{
            background: `url(${loginPageData?.BackgroundImage?.formats?.medium?.url}) center / cover transparent fixed`,
          }}
        >
          <MainTitle height={"130px"} logoHeight={"80px"} warnerLogo={true} />
          <BlurryWrapper
            imgUrl={loginPageData?.BackgroundImage?.formats?.medium?.url}
            new_styles={{
              width: "fit-content",
              height: "fit-content",
              margin: "auto",
              marginTop: width === 1366 ? "0px" : "140px",
              marginBottom: "10px",
            }}
            new_class={"BlurryWrapper__helper_login"}
          >
            <form
              onSubmit={(e) => handleRequest(e, formData)}
              className={styles.formWrapper}
              style={{}}
            >
              <div className={styles.loginFormLogo}>
                <Logo width={"300px"} />
              </div>
              <div className={styles.headline}>
                <div className={styles.loginTitleWrapper}>
                  <Heading txt={loginPageData.Title} fontSize={"24px"} />
                </div>
                {width > 1324 ? (
                  <div className={styles.desktopDescription}>
                    <Markdown>{loginPageData?.DesktopDescription}</Markdown>
                  </div>
                ) : (
                  <div className={styles.mobileDescription}>
                    <Markdown>{loginPageData?.MobileDescription}</Markdown>
                  </div>
                )}
              </div>
              <div className={styles.inputSection}>
                <div className={styles.selectBoxWrapper}>
                  <InputCard
                    label={"Hotel"}
                    selectBox={true}
                    number={1}
                    name={"hotelId"}
                    selectedHotel={selectedHotel}
                    setSelectedHotel={setSelectedHotel}
                    selectBoxContent={loginPageData.Hotels}
                    setFormData={(key, value) => manageFormData(key, value)}
                  />
                </div>
                <div className={styles.inputWrapper}>
                  <InputCard
                    label={"Surname:"}
                    placeholder={"Please enter surname:"}
                    name={"surname"}
                    number={2}
                    setFormData={(key, value) => manageFormData(key, value)}
                  />
                  <InputCard
                    label={"Holiday Reference Number:"}
                    placeholder={"Please enter your holiday reference number:"}
                    name={"bookingId"}
                    number={3}
                    setFormData={(key, value) => manageFormData(key, value)}
                  />
                </div>
                {isWaitingToLogIn ? <LoadingContainer /> : null}
                <article className={styles.errorInfoWrapper}>
                  {isError && !isWaitingToLogIn ? (
                    <Information
                      new_styles={{
                        width: "100%",
                        height: "auto",
                        backgroundColor: "#ac1a1b",
                      }}
                      fullyColoredClass={"fullyColoredClass"}
                      flexDirection={"row"}
                      txt={isError}
                      icon={"exclamation.svg"}
                    />
                  ) : null}
                </article>
                <div className={styles.btnWrapper}>
                  <Button
                    backgroundColor={"#515d89"}
                    txt={"Go to my account"}
                    onClick={(e) => handleRequest(e, formData)}
                  />
                </div>
                <div className={styles.helpWrapper}>
                  <IndicatiorCircle txt={"?"} backgroundColor={"#dd2828"} />
                  <Link className={styles.helpLink} to={"/help"}>
                    Need some help? Click here
                  </Link>
                </div>
              </div>
            </form>
          </BlurryWrapper>
          {hasSessionExpired ? (
            <AlertBox
              txt={"Your session expired. Please log in again."}
              button={
                <Button
                  backgroundColor={"#515d89"}
                  txt={"OK"}
                  onClick={() => setHasSessionExpired(false)}
                />
              }
            />
          ) : null}
        </section>
      )}
      {bannerTexts.length > 0 ? (
        <PromotionalBanner content={bannerTexts} />
      ) : null}
    </>
  );
};

export default LoginOld;
